var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zoom-in-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg zoom-in",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "zoom-in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.38,3.19A11.23,11.23,0,1,0,25.62,14.42,11.19,11.19,0,0,0,14.38,3.19ZM0,14.42A14.46,14.46,0,1,1,14.46,28.88,14.44,14.44,0,0,1,0,14.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.31,22.35a1.57,1.57,0,0,1,2.23,0l7,7a1.58,1.58,0,0,1-2.23,2.23l-7-7A1.57,1.57,0,0,1,22.31,22.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.38,8A1.57,1.57,0,0,1,16,9.65v9.62a1.62,1.62,0,0,1-3.23,0V9.65A1.62,1.62,0,0,1,14.38,8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8,14.42a1.57,1.57,0,0,1,1.62-1.61h9.61a1.58,1.58,0,0,1,1.62,1.61A1.63,1.63,0,0,1,19.23,16H9.62A1.58,1.58,0,0,1,8,14.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.a63f5b3993cc2990ddf86ddcd10332cb.svg";
export { ForwardRef as ReactComponent };